import { Navigate, useSearchParams } from 'react-router'

/**
 * /trust-score-setup was the old "Build Your Identity" page. Links to it still
 * exist in emails and bookmarks, so it forwards to /trust, keeping the
 * competition's `required` score and the `redirect` back to it.
 */
export function TrustScoreSetupRedirect() {
  const [params] = useSearchParams()
  const kept = new URLSearchParams()
  for (const key of ['required', 'redirect']) {
    const value = params.get(key)
    if (value) kept.set(key, value)
  }
  const query = kept.toString()
  return <Navigate to={query ? `/trust?${query}` : '/trust'} replace />
}
